<div class="d-flex flex-wrap gap-4">
  <app-mdb-button [text]="'SAVE'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="saveNewSettings()" />
</div>

@if (model()) {
<app-setting-form [setting]="model()!"
                  (formGroupOutput)="formGroup = $event"/>
}
@if (!model()) {
  <app-spinner></app-spinner>
}
